




































































import Vue from 'vue';
import { cloneDeep, each } from 'lodash';
import {
  BPagination,
  BRow,
  BCol,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue';

import { ZenObjectTable } from 'zenComponents';
import ZenButton from '@reciprocity/button';
import GenericCard from '@/components/cards/GenericCard.vue';
import { fetchJiraIssues, linkJiraIssue } from '@/utils/crudActions';

export default Vue.extend({
  name: 'JiraLinkCard',
  components: {
    BCol,
    BFormInput,
    BFormRadio,
    BFormRadioGroup,
    BInputGroup,
    BInputGroupAppend,
    BPagination,
    BRow,
    ZenObjectTable,
    GenericCard,
    ZenButton,
  },
  props: {
    csrfToken: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    objectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      searchString: '',
      selectedIssueIndex: null,
      rawTableRows: [],
      tableColumns: [
        { key: 'index', label: ' ', thStyle: { width: '1px' } },
        { key: 'key', label: 'Key' },
        { key: 'title', label: 'Summary' },
      ],
      pageSize: 10,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    tableRows() {
      const newItems = cloneDeep(this.rawTableRows);
      if (this.selectedIssueIndex !== null) {
        newItems[this.selectedIssueIndex]._rowVariant = 'active';
      }
      return newItems;
    },
    pageOffset() {
      return (this.currentPage - 1) * this.pageSize;
    },
  },
  methods: {
    async search() {
      if (this.searchString.trim().length === 0 || this.loading) {
        return;
      }

      try {
        this.loading = true;
        const jsonResponse = await this.fetchJiraIssues({
          searchString: this.searchString,
        });
        const issues = [];
        each(jsonResponse, value => {
          const issueData = {
            key: value.key,
            id: Number(value.id),
            title: value.name,
            imageUrl: value.issueType.iconUrl,
            link: value.permaLink,
          };
          issues.push(issueData);
        });
        this.rawTableRows = issues;
      } catch (error) {
        window.GGRC.Notify({
          type: 'error',
          message: error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    selectJiraIssue(_, index) {
      this.selectedIssueIndex = this.pageOffset + index;
    },
    async save() {
      try {
        const selectedIssue = this.rawTableRows[this.selectedIssueIndex];
        const data = {
          csrf: this.csrfToken,
          issueId: selectedIssue.id,
          objType: this.objectType,
          objId: this.objectId,
        };
        await this.linkJiraIssue(data);
        window.GGRC.zenModal.$emit('reloadPage');
        this.$emit('close');
      } catch (error) {
        window.GGRC.Notify({
          type: 'error',
          message: error.message,
        });
      }
    },
    openTypeSelectionCard() {
      window.GGRC.zenModal.show({
        type: 'JiraTypeSelectionCard',
        data: {
          objectType: this.objectType,
          objectId: this.objectId,
          csrfToken: this.csrfToken,
        },
        config: { ignoreUrl: true },
      });
    },
    fetchJiraIssues,
    linkJiraIssue,
  },
});
